import { render, staticRenderFns } from "./human-resource-favorites.vue?vue&type=template&id=0cc9b4eb"
import script from "./human-resource-favorites.vue?vue&type=script&lang=js"
export * from "./human-resource-favorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports